<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isLopperDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" :readonly="true">
        <template slot="associatedId">
          <el-table :data="chooseData" style="width: 100%">
            <el-table-column v-if="detailFormData.looperType === 3" key="goodsNo" prop="goodsNo" label="商品编号"></el-table-column>
            <el-table-column v-if="detailFormData.looperType === 3" key="cover" prop="cover" label="商品图片" width="180">
              <template slot-scope="data">
                <img class="table-img" v-if="data.row.cover && data.row.cover.length > 0" :src="imgUrl + data.row.cover.split(',')[0]">
              </template>
            </el-table-column>
            <el-table-column v-if="detailFormData.looperType === 3" key="title" prop="title" label="商品标题"></el-table-column>
            <el-table-column v-if="detailFormData.looperType === 3" key="integral" prop="integral" label="积分"></el-table-column>
            <el-table-column v-if="detailFormData.looperType === 2" key="title2" prop="title" label="资讯标题"></el-table-column>
            <el-table-column v-if="detailFormData.looperType === 2" key="coverPath" prop="coverPath" label="资讯图片" width="180">
              <template slot-scope="data">
                <img class="table-img" v-if="data.row.coverPath && data.row.coverPath.length > 0" :src="imgUrl + data.row.coverPath.split(',')[0]">
              </template>
            </el-table-column>
            <el-table-column v-if="detailFormData.looperType === 2" key="typeName" prop="typeName" label="资讯标签"></el-table-column>
          </el-table>
        </template>
      </wt-detail-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Lopper-view',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      formCode: 'MODULES_LOPPER',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/lopper/lopperUpdate',
      formAddUrl: '/modules/lopper/lopperAdd',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        className: 'wt-section-long-content',
        elements: [
          { name: '标题', key: 'name', type: 'text', disabled: true, className: 'wt-col-12' },
          { name: '图片', key: 'coverPathList', type: 'image', disabled: true, className: 'wt-col-12' },
          { name: '排序', key: 'orderNum', type: 'text', disabled: true, className: 'wt-col-12' },
          { name: '链接方式',
            key: 'looperType',
            type: 'select',
            disabled: true,
            className: 'wt-col-12',
            data: [
              { label: '自定义', value: 1 },
              { label: '关联资讯', value: 2 },
              { label: '关联商品', value: 3 },
              { label: '外部链接', value: 4 }
            ] },
          { name: '链接', key: 'associatedId', type: 'text', disabled: true, className: 'wt-col-12' }]
      },
      chooseData: []
    }
  },
  created() {
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    },
    looperTypeChange(val) {
      if (val === 1) {
        this.detailForm.elements[4].name = '内容'
        this.detailForm.elements[4].type = 'editor'
        this.detailForm.elements[4].key = 'content'
      }
      if (val === 2) {
        this.detailForm.elements[4].name = '资讯'
        this.detailForm.elements[4].type = 'custom'
        this.detailForm.elements[4].key = 'associatedId'
      }
      if (val === 3) {
        this.detailForm.elements[4].name = '商品'
        this.detailForm.elements[4].type = 'custom'
        this.detailForm.elements[4].key = 'associatedId'
      }
      if (val === 4) {
        this.detailForm.elements[4].name = '链接'
        this.detailForm.elements[4].type = 'text'
        this.detailForm.elements[4].key = 'content'
      }
    }
  },
  computed: {
    ...mapState({
      isLopperDetailLoading: state => state.lopper.isLopperDetailLoading,
      detailFormData: state => state.lopper.lopperDetailData
    })
  },
  watch: {
    isLopperDetailLoading(val) {
      if (!val) {
        this.detailFormData.coverPathList = [{ fileUrl: this.detailFormData.coverPath }]
        this.looperTypeChange(this.detailFormData.looperType)
        if (this.detailFormData.looperType === 2) {
          this.chooseData = [{
            id: this.detailFormData.associatedId * 1,
            coverPath: this.detailFormData.infomationCover,
            title: this.detailFormData.infomationTitle,
            typeName: this.detailFormData.infomationTypeName
          }]
        }
        if (this.detailFormData.looperType === 3) {
          this.chooseData = [{
            id: this.detailFormData.associatedId * 1,
            goodsNo: this.detailFormData.goodsNo,
            cover: this.detailFormData.goodsCover,
            title: this.detailFormData.goodsTitle,
            integral: this.detailFormData.goodsIntegral
          }]
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
